import { Route, Routes } from 'react-router';
import ContactUs from "./contactus/ContactUs";
import NavBar from "./navbar/NavBar";
import Home from './components/Home';

function App() {
  return (
    <>
    <NavBar />
    {/* <LandingPageBody />
    <Footer /> */}
    <Routes>
      <Route path='/' element={<Home />}></Route>
      <Route path='/contact-us' element={<ContactUs />}></Route>
    </Routes>
    {/* <ContactUs /> */}
    </>
  );
}

export default App;
